// removed by extract-text-webpack-plugin
module.exports = {"about":"src-components-about----style-module---about---2DE7y","about__inner":"src-components-about----style-module---about__inner---30Cal","about__title":"src-components-about----style-module---about__title---1JBzu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/about/style.module.scss
// module id = 313
// module chunks = 35783957827783